// extracted by mini-css-extract-plugin
module.exports = {"features":"Features_features__A2xyc","feature":"Features_feature__qd4WO","featureIcon":"Features_featureIcon__IRRZd","featureText":"Features_featureText__IUd_l"};